'use client'

import { Phone, Mail, MessageCircle, ArrowRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
const TestActions = () => {
  const { i18n } = useTranslation()
  return (
    <div className="mx-auto w-11/12 max-w-6xl p-4" dir={i18n.dir()}>
      <div className="relative flex flex-col overflow-hidden rounded-2xl border border-border bg-white/10 backdrop-blur sm:flex-row">
        <div className="after:-z-1 relative w-full bg-blue-900 after:absolute after:right-0 after:top-0 after:h-full after:w-16 after:translate-x-10 after:skew-x-[10deg] after:bg-blue-900 after:content-[''] sm:w-[40%] sm:after:w-20">
          <div className="relative px-6 py-6 md:px-8">
            <div className="flex items-center justify-between px-0.5">
              <h2 className="text-3xl font-bold text-white sm:mb-4 md:text-4xl">Get in Touch</h2>
              <div className="my-4 flex justify-start sm:hidden">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 256 256"
                  className="size-10 fill-white text-white"
                >
                  <path d="M71.932 132.364H48.261a5.617 5.617 0 0 1-4.994-3.043 5.625 5.625 0 0 1 .413-5.834l21.592-30.354c1.228-1.722 1.4-3.9.461-5.825-.421-.868-1.711-2.897-4.53-3.026l-.323-.006a7.005 7.005 0 0 0-6.997 6.997c0 3.102-2.517 5.62-5.62 5.62s-5.62-2.518-5.62-5.62c0-10.057 8.18-18.237 18.237-18.237.276 0 .545.006.818.017 6.145.278 11.425 3.766 14.14 9.33a16.95 16.95 0 0 1-1.405 17.267l-15.278 21.477h12.777a5.617 5.617 0 1 1 0 11.237zm42.791 0a5.622 5.622 0 0 1-5.62-5.62v-3.319h-22.47a5.616 5.616 0 0 1-4.998-3.051 5.628 5.628 0 0 1 .433-5.845l28.088-39.152a5.608 5.608 0 0 1 6.286-2.074 5.62 5.62 0 0 1 3.9 5.35v33.532h3.373c3.102 0 5.62 2.518 5.62 5.62s-2.518 5.62-5.62 5.62h-3.372v3.319a5.62 5.62 0 0 1-5.62 5.62zm-17.139-20.179h11.521V96.13l-11.52 16.056zm69.093 70.495a5.63 5.63 0 0 1-2.838-.77 5.623 5.623 0 0 1-2.007-7.691l23.245-39.63H166.68a5.62 5.62 0 0 1 0-11.24h28.21a5.622 5.622 0 0 1 4.847 8.464l-28.213 48.088a5.599 5.599 0 0 1-4.847 2.779zm-51.887 0a5.62 5.62 0 0 1-4.887-8.385l55.59-98.407a5.622 5.622 0 0 1 9.788 5.53l-55.593 98.404a5.609 5.609 0 0 1-4.898 2.858z" />
                  <path d="M120.171 246.621c-65.487 0-118.764-53.277-118.764-118.764S54.684 9.092 120.17 9.092 238.936 62.37 238.936 127.857c0 3.102-2.518 5.62-5.62 5.62s-5.62-2.518-5.62-5.62c0-59.291-48.237-107.525-107.525-107.525-59.288 0-107.524 48.234-107.524 107.525S60.883 235.38 120.17 235.38c38.065 0 73.662-20.437 92.896-53.34a5.622 5.622 0 0 1 7.688-2.014 5.623 5.623 0 0 1 2.015 7.688c-21.24 36.334-60.553 58.906-102.599 58.906z" />
                  <path d="M233.316 133.477a5.598 5.598 0 0 1-3.973-1.647l-15.371-15.37a5.619 5.619 0 1 1 7.947-7.947l11.397 11.394 11.397-11.394a5.619 5.619 0 1 1 7.947 7.946l-15.37 15.37a5.593 5.593 0 0 1-3.974 1.648z" />
                </svg>
              </div>
            </div>
            <p className="px-0.5 text-gray-100 md:mt-2">
              Reach out anytime via call, WhatsApp, or email!
            </p>
          </div>
        </div>

        {/* Right section */}
        <div className="flex w-full flex-col justify-center px-6 py-4 sm:w-[60%] md:px-8">
          {/* Contact List */}
          <div className="space-y-4">
            <div className="group flex items-center justify-end space-x-6 md:space-x-4 rtl:space-x-reverse">
              <span className="text-md font-medium text-blue-600 group-hover:text-blue-900 dark:text-blue-200 dark:group-hover:text-blue-800">
                072834 5555
              </span>
              <div className="flex size-10 items-center justify-center rounded-full bg-blue-700 text-blue-100 transition-all duration-300 group-hover:bg-blue-200 group-hover:text-blue-700 dark:group-hover:bg-blue-700/40 dark:group-hover:text-blue-200">
                <Phone className="size-4" />
              </div>
            </div>

            <div className="group flex items-center justify-end space-x-6 md:space-x-4 rtl:space-x-reverse">
              <span className="text-md font-medium text-blue-600 group-hover:text-blue-900 dark:text-blue-200 dark:group-hover:text-blue-800">
                072833 3333
              </span>
              <div className="flex size-10 items-center justify-center rounded-full bg-blue-700 text-blue-100 transition-all duration-300 group-hover:bg-blue-200 group-hover:text-blue-700 dark:group-hover:bg-blue-700/40 dark:group-hover:text-blue-200">
                <MessageCircle className="size-4" />
              </div>
            </div>

            <div className="group flex items-center justify-end space-x-6 md:space-x-4 rtl:space-x-reverse">
              <span className="text-md font-medium text-blue-600 group-hover:text-blue-900 dark:text-blue-200 dark:group-hover:text-blue-800">
                internet.sales@Roshan.af
              </span>
              <div className="flex size-10 items-center justify-center rounded-full bg-blue-700 text-blue-100 transition-all duration-300 group-hover:bg-blue-200 group-hover:text-blue-700 dark:group-hover:bg-blue-700/40 dark:group-hover:text-blue-200">
                <Mail className="size-4" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TestActions
